import {
  ADD_LOADER,
  REMOVE_LOADER,
  SUBMIT_FORM_REQUEST,
  SUBMIT_FORM_SUCCESS,
  SUBMIT_FORM_FAILURE,
} from './types';

export const action = type => payload => ({
  type,
  payload,
});

export const addLoader = action(ADD_LOADER);
export const removeLoader = action(REMOVE_LOADER);

export const submitFormRequest = action(SUBMIT_FORM_REQUEST);
export const submitFormSuccess = action(SUBMIT_FORM_SUCCESS);
export const submitFormFailure = action(SUBMIT_FORM_FAILURE);
